import { Partner } from "@/model/Partner";
import { Versicherungsnehmer } from "@/model/Versicherungsnehmer";
import { Vermittlerdaten } from "@/model/Vermittlerdaten";

export class Personendaten {
  versicherungsnehmer = new Versicherungsnehmer();
  verwalter = new Partner();
  verwalterAktiv = false;
  mitversichertePerson = new Partner();
  vermittler = new Vermittlerdaten();
  ansprechPartner = new Partner();
}
